module.exports = __webpack_public_path__ + "img/badTooth.27d597ef.png";